function Zaad() {
  return (
    <div className="px-40 py-20  md:px-5 md:py-10 flex justify-center items-center">
      <div className="w-[70%] h-full md:w-full py-7 border flex flex-col justify-center  items-center">
        <div className="mb-10 flex justify-center items-center flex-col">
          <h1 className="text-2xl md:text-xl  font-extrabold  text-black flex items-center  flex-col ">
            <span className="primaryUser font-normal">
              <img src="/edahab.png" className="w-28 h-24 " />{" "}
            </span>{" "}
            Edahab Payment
          </h1>
        </div>
        <div className="w-full px-10 md:px-5">
          <form>
            <div className="mb-4 ">
              <label
                className="block text-gray-700 font-medium mb-2"
                htmlFor="email"
              >
                FullName
              </label>
              <input
                className="bg-white border border-gray-400 rounded-md w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:border-indigo-500"
                id="email"
                type="email"
              />
            </div>
            <div className="mb-6">
              <label
                className="block text-gray-700 font-medium mb-2"
                htmlFor="password"
              >
                Number
              </label>
              <input
                className="bg-white border border-gray-400 rounded-md w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:border-indigo-500"
                id="number"
                type="phone"
              />
            </div>
            <div className="mb-6">
              <label
                className="block text-gray-700 font-medium mb-2"
                htmlFor="password"
              >
                key
              </label>
              <input
                className="bg-white border border-gray-400 rounded-md w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:border-indigo-500"
                id="price"
                type="number"
              />
            </div>
            <div className="mb-6">
              <label
                className="block text-gray-700 font-medium mb-2"
                htmlFor="password"
              >
                Price
              </label>
              <select
                className="bg-white border border-gray-400 rounded-md w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:border-indigo-500"
                placeholder="select type of money"
                value="$100"
              >
                <option>$100</option>

                <option>Doller</option>
                <option>shillig</option>
              </select>
            </div>
            <div className="flex justify-center  items-center  ">
              <button className="bg-[#e6f060] text-white w-full font-semibold text-xl rounded-md py-2 px-4 hover:bg-indigo-600">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Zaad;
